import EcoSpecSelector from 'eco-design/sections/eco-spec-selector';
import { Spin } from 'antd';
import getProductSpec from '../../context/getSpec';
import BottomAction from '../../comps/BottomAction';
import css from './index.module.scss';

export default function Spec({ productSpecs, theme, title }: any) {
    return (
        <>
            <div className={`spec ${css.spec}`}>
                {productSpecs?.items?.length > 0 || productSpecs?.selector?.items?.length > 0 ? (
                    <EcoSpecSelector {...productSpecs} />
                ) : (
                    <>
                        {getProductSpec(title, theme)}
                        <Spin />
                    </>
                )}
            </div>
            <BottomAction pageType="specs" />
        </>
    );
}
